import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Header from '../Header';
import Footer from '../Footer';
import { API_URL, BASE_URL } from '../Config';
import config from '../common/Config';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const PurchasesOrder = () => {
	const [activeTab, setActiveTab] = useState('ordered');
	const purchaseOrderRef = useRef(null);
	const accessToken = localStorage.getItem('accessToken');
	const company_tax_type = localStorage.getItem('company_tax_type');

	const fetchProductPrint = async (pdtId) => {
		const formData = new FormData();
		formData.append('id', pdtId);
		try {
			const response = await fetch(`${API_URL}/purchases/purchases_print`, {
				method: 'POST',
				headers: { authorization: `Bearer ${accessToken}` },
				body: formData,
			});
			if (!response.ok) throw new Error('Failed to fetch order details');
			const data = await response.json();
			generatePDF(data);
		} catch (error) {
			console.error('Error:', error);
		}
	};

	const generatePDF = (data) => {
		const doc = new jsPDF();
		const header = [
			[`Order Summary for ${data.shop_details.shop_name}`, `Address: ${data.shop_details.address}`],
			[`COMPANY REG NO: ${data.shop_details.company_reg_no}`, `Email: ${data.shop_details.email}`],
		];
		const header2 = [
			[`${data.purchases_details.name}`, `${data.purchases_details.reference_no}`],
			[`PO No: ${data.purchases_details.reference_no}`, `Date: ${data.purchases_details.date}`],
			[`Cust Account No: ${data.purchases_details.po_id}`, `Due Date: ${data.purchases_details.date}`],
		];
		const columns = [
			{ title: 'Description', dataKey: 'description' },
			{ title: 'Quantity', dataKey: 'quantity' },
		];
		const tableData = data.purchases_items.map(item => ({
			description: `${item.product_code} - ${item.product_name}`,
			quantity: parseInt(item.quantity, 10),
		}));

		doc.autoTable({ head: header, startY: 10 });
		doc.autoTable({ head: header2, startY: doc.lastAutoTable.finalY + 5 });
		doc.autoTable({ columns, body: tableData, startY: doc.lastAutoTable.finalY + 10 });
		doc.save(`invoice_${Date.now()}.pdf`);
	};

	const getPurchaseOrderList = (tab) => {
		const $table = $(purchaseOrderRef.current);
		if ($.fn.DataTable.isDataTable($table)) {
			$table.DataTable().destroy();
		}

		let endpoint;
		if (tab === 'received') {
			endpoint = `${API_URL}/purchases/grnlist_received`;
		} else if (tab === 'pending') {
			endpoint = `${API_URL}/purchases/grnlist_pending`; // <-- You need to create this endpoint in your backend
		} else {
			endpoint = `${API_URL}/purchases/grnlist_ordered`;
		}

		$table.DataTable({
			processing: true,
			serverSide: true,
			ajax: {
				url: endpoint,
				type: 'GET',
				headers: { authorization: `Bearer ${accessToken}` },
				data: function (d) {
					return {
						draw: d.draw,
						start: d.start,
						length: d.length,
						search: d.search?.value || '',
					};
				},
				dataSrc: json => (Array.isArray(json.data) ? json.data : []),
			},
			columns: [
				{ data: 'date', className: 'text-center' },
				{ data: 'reference_no', className: 'text-start' },
				{ data: 'supplier', className: 'text-start' },
				{ data: 'total_tax', className: 'text-end' },
				{ data: 'grand_total', className: 'text-end' },
				{
					data: 'status',
					className: 'text-center',
					render: data => {
						if (data === 'Draft') return 'Ordered';
						if (data === 'Partial') return 'Pending';
						if (data === 'Close') return 'Received';
						return data;
					},
				},
				{
					data: null,
					className: 'text-center',
					render: (data, type, row) => {
						const view = `<a href="${BASE_URL}/purchases/view/${row.id}" class="deductionbtn" title="View"><i class="bi bi-eye"></i></a>`;
						const edit = `<a href="${BASE_URL}/purchases/edit_po/${row.id}" class="deductionbtn" title="Edit PO"><i class="bi bi-pencil-square"></i></a>`;
						const addGrn = `<a href="${BASE_URL}/purchases/add_grn/${row.id}" class="deductionbtn" title="Add GRN"><i class="bi bi-file-earmark-plus"></i></a>`;
						const print = `<a href="${config.BASE_URL}/purchaseOrder/invoice/${row.id}" class="deductionbtn" title="Print Invoice"><i class="bi bi-printer"></i></a>`;
						if (row.status === 'Draft') return `${view} ${edit} ${addGrn}`;
						if (row.status === 'Partial') return `${view} ${print} ${addGrn}`;
						return `${view} ${print}`;
					},
				},
			],
			ordering: false,
			pageLength: 50,
		});
	};

	useEffect(() => {
		if (!accessToken) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}
		getPurchaseOrderList(activeTab);
		return () => {
			if (purchaseOrderRef.current && $.fn.DataTable.isDataTable(purchaseOrderRef.current)) {
				$(purchaseOrderRef.current).DataTable().destroy();
			}
		};
	}, [activeTab]);

	return (
		<>
			<Header />

			<div className="breadcrumbs">
				<div className="container-fluid">
					<div className="row">
						<div className="col-12">
							<Link to="/Dashboard"><i className="fa fa-home"></i></Link>
							<Link to="/purchases/purchases_order">Purchases</Link>
							<span>Purchase Order</span>
						</div>
					</div>
				</div>
			</div>

			<div className="main-container">
				<div className="container-fluid">
					<ul className="nav nav-tabs mb-3">
						<li className="nav-item">
							<button
								className={`nav-link ${activeTab === 'ordered' ? 'active' : ''}`}
								onClick={() => setActiveTab('ordered')}
							>
								Ordered
							</button>
						</li>
						<li className="nav-item">
							<button
								className={`nav-link ${activeTab === 'received' ? 'active' : ''}`}
								onClick={() => setActiveTab('received')}
							>
								Received
							</button>
						</li>
						<li className="nav-item">
							<button
								className={`nav-link ${activeTab === 'pending' ? 'active' : ''}`}
								onClick={() => setActiveTab('pending')}
							>
								Pending
							</button>
						</li>
						<li className="ms-auto">
							<Link to="/purchases/add">
								<button className="btn btn-sm btn-success">Add Purchase Order</button>
							</Link>
						</li>
					</ul>

					<div className="verical-scrl-wrapper common-table autoheight-table purchase-order">
						<table className="table table-bordered dataTable" ref={purchaseOrderRef}>
							<thead>
								<tr>
									<th>Date</th>
									<th>PO No</th>
									<th>Supplier</th>
									<th>{company_tax_type}</th>
									<th>Grand Total</th>
									<th>Status</th>
									<th>Action</th>
								</tr>
							</thead>
							<tbody />
						</table>
					</div>
				</div>
			</div>

			<Footer />
		</>
	);
};

export default PurchasesOrder;
